import {HttpModelConverter} from '../../../../../../../../core/converter/httpModel.converter';
import {SaleInvoiceConfigurationModel} from '../saleInvoiceConfiguration.model';
import {
    LovValueSummaryConverter
} from '../../../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from '@angular/core';
import {
    CommunicationConfigurationEmailConverter
} from "../../../../../../../../communication/configuration/email/common/api/model/converter/communicationConfigurationEmail.converter";
import {SaleInvoiceConfigurationBookModel} from "../saleInvoiceConfigurationBook.model";
import {UserSummaryConverter} from "../../../../../../../../account/modules/user/api/converter/userSummary.converter";
import {PermissionsConverter} from "../../../../../../../../common/converter/permissions.converter";

@Injectable({
    providedIn: 'root'
})
export class SaleInvoiceConfigurationBookConverter extends HttpModelConverter<SaleInvoiceConfigurationBookModel> {

    constructor(private userSummaryConverter: UserSummaryConverter,
                private permissionConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): SaleInvoiceConfigurationBookModel {
        return new SaleInvoiceConfigurationBookModel();
    }

    protected enrichObject(result: SaleInvoiceConfigurationBookModel, src: SaleInvoiceConfigurationBookModel) {
        result.user = this.userSummaryConverter.convert(src.user);
        result.permissions = this.permissionConverter.convert(src.permissions);
    }
}
